import PropTypes from 'prop-types';
import React from 'react';
import LanguageSelectionButtons from './LanguageSelectionButtons';

class ExhibitTitle extends React.Component {
  constructor(props) {
    super(props);

    this.chooseLanguage = this.chooseLanguage.bind(this);
  }

  chooseLanguage(language) {
    this.props.chooseLanguage(language);
  }

  render() {
    const { language } = this.props;
    return (
      <div className="exhibit-title">
        <h1>Ultimate Dinosaurs</h1>
        <p>Audio Guide | Guia de Audio</p>
        <LanguageSelectionButtons
          chooseLanguage={this.chooseLanguage}
          language={language}
        />
      </div>
    );
  }
}

ExhibitTitle.propTypes = {
  chooseLanguage: PropTypes.func.isRequired,
  language: PropTypes.string,
};

ExhibitTitle.defaultProps = {
  language: 'en',
};

export default ExhibitTitle;



// WEBPACK FOOTER //
// ./src/ExhibitTitle.js